import { default as getGlobalSettingsAccountMailboxInfo } from 'owa-account-source-list-store/lib/selectors/getGlobalSettingsAccountMailboxInfo';
import type { MailboxInfo } from 'owa-client-types';
import {
    getAccountKeyForMailboxInfo,
    isSameCoprincipalAccountMailboxInfos,
} from 'owa-client-types';
import { getStore } from '../store/store';
import type { AccountConfiguration } from '../store/schema/OwaSessionStore';
import { trace } from 'owa-trace';

export function getAccountSettingsInternal(
    mailboxInfo: MailboxInfo
): AccountConfiguration | undefined {
    const store = getStore();
    if (
        store.allowDefaultDataReturn &&
        store.userConfiguration === undefined &&
        store.nonGlobalAccountDataMap.size === 0
    ) {
        trace.warn(
            `getAccountSettingsInternal: Store completely empty, returning undefined. MailboxType: ${mailboxInfo?.type}, DefaultFolders: ${store?.defaultFolderIdToNameMap?.size}`
        );
        // there is not any configuration data set in the store and we allow default data
        // so we just return undefined here rather than checking the global settings account
        return undefined;
    }

    if (mailboxInfo?.type === 'UnifiedInbox') {
        // For Unified Inbox, we return the global settings account configuration
        trace.info(
            `getAccountSettingsInternal: Using global config for UnifiedInbox. HasGlobalConfig: ${!!store?.userConfiguration}`
        );
        return store?.userConfiguration;
    }

    // Can use IsKeySameAccountAsGlobalSettingsAccount after updating testing
    const settings = isSameCoprincipalAccountMailboxInfos(
        getGlobalSettingsAccountMailboxInfo(),
        mailboxInfo
    )
        ? store.userConfiguration
        : store.nonGlobalAccountDataMap.get(getAccountKeyForMailboxInfo(mailboxInfo));
    return settings;
}
